import React from 'react';
import ProformaJiraIssueFormsGeneral from '@atlassian/jira-proforma-issue-forms-general';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import UFOSegment from '@atlassian/jira-ufo-segment';

const ProformaJiraIssueFormsGeneralWrapper = () => (
	<UFOSegment name="proforma-jira-issue-forms-general-wrapper">
		<AuthenticationCheck>
			<ProformaJiraIssueFormsGeneral />
		</AuthenticationCheck>
	</UFOSegment>
);
export default ProformaJiraIssueFormsGeneralWrapper;
